import { Link } from "react-router-dom";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { areasData } from "../../../mocks/homeData";

export default function AreasSection() {
  return (
    <section className="py-20 md:py-28 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12">
              <p className="section-label mb-3">{areasData.label}</p>
              <h2 className="section-title">{areasData.title}</h2>
              <p className="section-subtitle">{areasData.subtitle}</p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {areasData.active.map((area) => (
              <ScrollReveal key={area.name} direction="up">
                <Link to={area.href} className="group block relative overflow-hidden rounded-lg">
                  <div className="aspect-[3/2] overflow-hidden">
                    <img
                      src={area.image}
                      alt={area.name}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-airdoa-navy/80 via-airdoa-navy/20 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="text-2xl font-serif font-semibold text-white">{area.name}</h3>
                    <p className="mt-1 text-xs font-medium tracking-wide text-airdoa-gold">
                      {area.status}
                    </p>
                  </div>
                </Link>
              </ScrollReveal>
            ))}

            {areasData.preparing.map((area, idx) => (
              <ScrollReveal key={area.name} direction="up" delay={idx * 80}>
                <div className="relative overflow-hidden rounded-lg bg-white border border-airdoa-gray-light/30">
                  <div className="aspect-[3/2] flex flex-col items-center justify-center p-6">
                    <div className="w-12 h-12 flex items-center justify-center text-airdoa-gray/40 mb-3">
                      <i className="ri-time-line text-2xl" />
                    </div>
                    <h3 className="text-lg font-serif font-semibold text-airdoa-navy">{area.name}</h3>
                    <p className="mt-1 text-xs text-airdoa-gray">{area.status}</p>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}